import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [],
  templateUrl: './spinner.component.html',
})
export default class SpinnerComponent {
  @Input() text: string = '';
  constructor(
  ) {}
}
